import { createContext, useContext, useEffect, useState } from 'react';
import usePolledResource from '../util/usePolledResource';
import UWEEntityApi from '../api/UWEEntityApi';
import useIsEmbedded from '../util/useIsEmbedded';
import { AuthContext } from './AuthContext';

const OpenCasesContext = createContext();

export const OpenCasesProvider = ({ children }) => {
  const auth = useContext(AuthContext);
  const user = auth?.user?.user;
  const [data, setData] = useState([]);
  // Only consumed by the org-unit dropdown in the header, which is hidden
  // entirely when embedded — skip the fetch and the 60s repoll too.
  const isEmbedded = useIsEmbedded();

  const [openCases] = usePolledResource({
    resourceFn: () => (!isEmbedded && auth?.user?.user && auth.user?.organizationalUnits?.length > 1 ? UWEEntityApi.getOpenCases() : Promise.resolve([])),
    dependencies: [user?.id],
    interval: 1000 * 60,
    initialValue: [],
    enabled: !isEmbedded,
  });

  useEffect(() => {
    if (!openCases) return;
    setData(openCases);
  }, [openCases]);

  return <OpenCasesContext.Provider value={data}>{children}</OpenCasesContext.Provider>;
};

export const useOpenCases = () => useContext(OpenCasesContext);
